<template>
	<div class="field-wrap">
		<FieldCheckbox
			v-if="data.type === 'checkbox'"
			:name="name"
			:data="data"
		/>
		<FieldHidden v-if="data.type === 'hidden'" :name="name" :data="data" />
		<FieldInput
			v-if="data.type === 'input'"
			@input-changed="handleFieldChange"
			:name="name"
			:data="data"
		/>
		<FieldSelect
			v-if="data.type === 'select'"
			@select-changed="handleFieldChange"
			:name="name"
			:data="data"
		/>
	</div>
</template>

<script>
import { mutations } from "../store";
import FieldCheckbox from "./FieldCheckbox.vue";
import FieldHidden from "./FieldHidden.vue";
import FieldInput from "./FieldInput.vue";
import FieldSelect from "./FieldSelect.vue";

export default {
	components: {
		FieldCheckbox,
		FieldHidden,
		FieldInput,
		FieldSelect
	},

	data() {
		return {
			field: null
		};
	},

	methods: {
		handleFieldChange(e) {
			this.field = e;
		}
	},

	mounted() {
		if (this.data.type !== "hidden") {
			if (this.data.is_required === true) {
				mutations.tallyRequiredField();
			}
		}
	},

	props: {
		data: {
			type: Object,
			required: true
		},

		name: {
			type: String,
			required: true
		}
	},

	watch: {
		field(newValue, oldValue) {
			if (oldValue === null) {
				if (this.data.is_required === true) {
					mutations.tallyCompletedField();
				}
			}
		}
	}
};
</script>
